// Shared logic for the vector upload views (UploadVector = create, UploadVectorEdit = edit).
// Extracted to remove duplicated code (SonarQube). Members below are byte-identical between the
// two files, so behavior is unchanged. Each view keeps its own template and the members that differ
// (e.g. the `images` map, whose edit/delete icons resolve to different assets per view).
import generalImg from "@/assets/images/Group 11.svg";
import maxCharacterImg from "@/assets/images/Group 12.svg";
import customSplitImg from "@/assets/images/Group 13.svg";
import { findTypeName as findTypeNameUtil } from "@/utils/fileTypes";
const articleImg = customSplitImg;
const headerAllChunkImg = generalImg;
const headerFirstChunkImg = maxCharacterImg;
const wordImageImg = maxCharacterImg;
const pdfImageImg = maxCharacterImg;
// Chat/UploadFile (UploadCSV2VectorNew) uses [RequestSizeLimit(52428800)], which caps the whole multipart
// request, and every selected file goes out in that one request. Above it Kestrel drops the connection
// (ERR_CONNECTION_RESET) with no response, so the combined size is checked when files are added.
const MAX_UPLOAD_MB = 50;
// Room for multipart boundaries/headers and the vector settings sent alongside the files
const MULTIPART_OVERHEAD_BYTES = 64 * 1024;
const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024 - MULTIPART_OVERHEAD_BYTES;
export default {
  data() {
    return {
      maxUploadMB: MAX_UPLOAD_MB,
      DDType: [
        {
          id: 'General',
          name: 'General',
          value: 1,
          image: generalImg,
        },
        {
          id: 'MaxCharacter',
          name: 'MaxCharacter',
          value: 2,
          image: maxCharacterImg,
        },
        {
          id: 'CustomSplit',
          name: 'CustomSplit',
          value: 3,
          image: customSplitImg,
        },
        {
          id: 'Article',
          name: 'Article',
          value: 4,
          image: articleImg,
        },
        {
          id: 'HeaderAllChunk',
          name: 'HeaderAllChunk',
          value: 5,
          image: headerAllChunkImg,
        },
        {
          id: 'HeaderFirstChunk',
          name: 'HeaderFirstChunk',
          value: 6,
          image: headerFirstChunkImg,
        },
        {
          id: 'WordImage',
          name: 'WordImage',
          value: 7,
          image: wordImageImg,
        },
        {
          id: 'PDFImage',
          name: 'PDFImage',
          value: 8,
          image: pdfImageImg,
        },
      ],
      datadoctype: [
        { id: 'Csv', name: 'CSV', value: 1 },
        { id: 'Excel', name: 'Excel', value: 2 },
        { id: 'Pdf', name: 'PDF', value: 3 },
        { id: 'Word', name: 'Word', value: 4 },
        { id: 'Text', name: 'Text', value: 5 },
        { id: 'Powerpoint', name: 'PowerPoint', value: 6 },
      ],
      datavectortype: [
        { id: 'General', name: 'General', value: 1 },
        { id: 'Article', name: 'Article', value: 2 },
        { id: 'PriceList', name: 'PriceList', value: 3 },
      ],
      dataTemplate: [
        {
          modeType: "General",
          CSV: "CSV",
          Excel: "Excel",
          ExcelMultiColumn: "ExcelMultiColumn",
          PDF: "PDF",
          Word: "Word",
          Text: "Text",
          PowerPoint: "PowerPoint",
          label: "General",
          value: "General",
        },
        {
          modeType: "MaxCharacter",
          CSV: "CSV",
          Excel: "Excel",
          ExcelMultiColumn: "ExcelMultiColumn",
          PDF: "PDF",
          Word: "Word",
          Text: "Text",
          PowerPoint: "PowerPoint",
          label: "Max Character",
          value: "MaxCharacter"
        },
        {
          modeType: "CustomSplit",
          CSV: "CSV",
          Excel: "Excel",
          ExcelMultiColumn: "ExcelMultiColumn",
          PDF: "PDF",
          Word: "Word",
          Text: "Text",
          PowerPoint: "PowerPoint",
          label: "Custom Split",
          value: "CustomSplit"
        },
        {
          modeType: "Article",
          CSV: "CSV",
          Excel: "Excel",
          ExcelMultiColumn: "ExcelMultiColumn",
          PDF: "PDF",
          Word: "Word",
          Text: "Text",
          PowerPoint: "PowerPoint",
          label: "Article",
          value: "Article"
        },
        {
          modeType: "HeaderAllChunk",
          CSV: "CSV",
          Excel: "Excel",
          ExcelMultiColumn: "ExcelMultiColumn",
          PDF: "PDF",
          Word: "Word",
          Text: "Text",
          PowerPoint: "PowerPoint",
          label: "Header (All Chunk)",
          value: "HeaderAllChunk"
        },
        {
          modeType: "HeaderFirstChunk",
          CSV: "CSV",
          Excel: "Excel",
          ExcelMultiColumn: "ExcelMultiColumn",
          PDF: "PDF",
          Word: "Word",
          Text: "Text",
          PowerPoint: "PowerPoint",
          label: "Header (First Chunk Only)",
          value: "HeaderFirstChunk"
        },
      ],
      modeType: [
        {
          name: "Add",
          value: false,
        },
        {
          name: "Replace",
          value: true,
        },
      ],
      rules: {
        required: (value) => !!value || this.$t("requiredField"),
        // required2 : this.vectornameDuplicate || 'dup'
      },
      errors: {
        documentNameError: null,
        doctypeError: null,
        vectortypeError: null,
        modelTypeError: null,
      },
      requestVector: {
        modelType: null,
        modelId: null,
        vectordbName: null,
        entity: null,
        deleteAll: false,
        groupReplaceID: null,
        customCharacter: null,
        DetectLanguage: true,
        MaxLimitedCharacter: null,
        PersonalInfo: false,
      },
    };
  },

  computed: {
    fileTableHeaders() {
      return [
        { title: this.$t("fileName"), key: 'name', sortable: false },
        { title: this.$t("actions"), key: 'actions', sortable: false, width: '80px', align: 'center' },
      ];
    },
    fileFormats() {
      return [
        { label: "CSV", value: "CSV", icon: this.images.csvImg, color: "green" },
        { label: "Excel", value: "Excel", icon: this.images.excelImg, color: "green-darken-2" },
        { label: "Multi-Col", value: "ExcelMultiColumn", icon: this.images.fileexcelImg, color: "teal" },
        { label: "PDF", value: "PDF", icon: this.images.pdfImg, color: "red" },
        { label: "Word", value: "Word", icon: this.images.wordImg, color: "blue" },
        { label: "PPT", value: "PowerPoint", icon: this.images.pptImg, color: "orange" },
        { label: "TXT", value: "Text", icon: this.images.txtImg, color: "grey-darken-1" },
      ];
    },
    visibleFormats() {
    switch (this.selectedType) {
      case "MaxCharacter":
        return this.fileFormats;
      case "CustomSplit":
      case "Article":
        return this.fileFormats.filter(f =>
          ["PDF","Word","PPT","PowerPoint","Text"].includes(f.value)
        );
      case "HeaderAllChunk":
      case "HeaderFirstChunk":
        return this.fileFormats.filter(f =>
          ["CSV","ExcelMultiColumn"].includes(f.value)
        );
      default:
        return this.fileFormats;
    }
    },
    headers2() {
      return [
        {
          title: this.$t("no"),
          key: "number",
          align: "center",
          sortable: false,
          width: this.smAndUp ? "60px" : "30px",
        },
        {
          title: "Text_org",
          key: "textORG",
          align: "left",
          sortable: true,
          width: this.smAndUp ? "40%" : "300px",
        },
        {
          title: "Text_en",
          key: "textEN",
          align: "left",
          sortable: true,
          width: this.smAndUp ? "40%" : "300px",
        },
        {
          title: this.$t("manage"),
          key: "actions",
          align: "center",
          sortable: false,
          width: this.smAndUp ? "15%" : "auto",
        },
      ];
    },
    isUploadReady() {
      return [
        this.doctype?.value,
        this.vectortype?.value,
        this.requestVector?.modelType,
      ].every((value) => value !== null && value !== undefined && value !== "");
    },
    isIndeterminate() {
      return this.selectedFiles.length > 0 && this.selectedFiles.length < this.uploadedFiles.length;
    },
  },
  watch: {
    CheckboxShowAllText(newVal) {
      if (newVal) {
        this.ShowAll();
      } else {
        this.CloseShowAll();
      }
    },
    selectedFiles: {
      handler() {
        // Update selectAll checkbox state based on selected files
        if (this.selectedFiles.length === 0) {
          this.selectAll = false;
        } else if (this.selectedFiles.length === this.uploadedFiles.length) {
          this.selectAll = true;
        }
        // Note: indeterminate state is handled by the computed property isIndeterminate
      },
      deep: true,
    },
    requestVector: {
      handler(newVal) {
        if (newVal.modelType != 3) {
          this.requestVector.customCharacter = null;
        }
      },
      deep: true,
    },
    doctype: {
      handler(val) {
        if (this.errors.doctypeError) {
          this.errors.doctypeError = null;
        }
        this.vectortype = null;
        this.filterDDType = [];
        this.filterdatavectortype = [];
        if (val.value == 1 || val.value == 2) {
          this.filterdatavectortype = this.datavectortype.filter((e) => e.value != 2);
        } else {
          this.filterdatavectortype = this.datavectortype.filter((e) => e.value != 3);
        }

        this.filterDDType = [];
        this.requestVector.customCharacter = null;
        this.setTypeFile(val);
      },
    },
    vectortype: {
      handler(val) {
        if (val) {
          this.errors.vectortypeError = null;
        }
        this.filterDDType = [];
        this.requestVector.customCharacter = null;
        if (val?.value == 2) {
          this.filterDDType = this.DDType.filter((e) => e.value == 4);
        } else if (val?.value == 3 && (this.doctype?.value == 1 || this.doctype?.value == 2)) {
          this.filterDDType = this.DDType.filter((e) => e.value == 5 || e.value == 6);
        } else if (this.doctype.value == 4) {
          this.filterDDType = this.DDType.filter((e) => e.value == 1 || e.value == 2 || e.value == 3 || e.value == 7);
        } else if (this.doctype.value == 3) {
          this.filterDDType = this.DDType.filter((e) => e.value == 1 || e.value == 2 || e.value == 3 || e.value == 8);
        } else {
          this.filterDDType = this.DDType.filter((e) => e.value == 1 || e.value == 2 || e.value == 3);
        }
        this.requestVector.modelType = null;
      },
    },
    'requestVector.modelType'(val) {
      if (val) {
        this.errors.modelTypeError = null;
      }
    },
  },
  mounted() {
    this.GetDate();
    this.AutoRefresh();
    this.GetDDGroupReplaceDB();

    if (this.$route.query.name) {
      this.searchVectorDBName2 = this.$route.query.name;
      this.showTable = true;
      this.actionEdit = true;
      this.flagNew = false;
    } else {
      this.dataUpdate = 0;
      this.GetMaxLimitedCharacter();
    }
    if (this.requestVector.MaxLimitedCharacter == null) {
      this.ReFresh();
    }
  },
  methods: {
    btnDisableDelete(item) {
      return this.RoleId == 2 && item.createBy != this.Username;
    },
    prevStep() {
      this.step = "1";
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Select all files
        for(const file of this.uploadedFiles){
          file.checked = true;
        }
        this.selectedFiles = [...this.uploadedFiles];
      } else {
        // Deselect all files
        this.selectedFiles = [];
        for(const file of this.uploadedFiles){
          file.checked = false;
        }
      }
    },
    onItemCheckChange(item, checked) {
      if (checked) {
        if (!this.selectedFiles.some(f => f.id === item.id)) {
          this.selectedFiles.push(item);
        }
      } else {
        this.selectedFiles = this.selectedFiles.filter(f => f.id !== item.id);
      }
    },
    formatText(text) {
      // แปลงช่องว่างเป็น &nbsp; เพื่อให้รักษาช่องว่างได้
      if(text){
        return text.replaceAll(' ', '&nbsp;');
      }
      return "-";      
    },
    numericKey: function (evt) {
      evt = evt || window.event; //NOSONAR
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*(?:\.\d*)?$/.test(expect) || Number.parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event; //NOSONAR
      let charCode = evt.which ? evt.which : evt.keyCode;
      // กำหนด Regular Expression สำหรับตรวจสอบตัวอักษรไทย, อังกฤษ, ตัวเลข, เครื่องหมายขีด และเครื่องหมายขีดล่าง
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F\-_]+$/;

      if (validCharactersRegex.test(String.fromCodePoint(charCode))) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    checkValidate() { //NOSONAR
      if (this.searchVectorDBName2 == "" || this.searchVectorDBName2 == null) {
        return this.$t("requiredField");
      } else if (this.VectorDBNameDuplicate == this.searchVectorDBName2) { //NOSONAR
        return this.$t("duplicate");
      }
      return true;
    },
    checkCustomCharacterValidate() {
      if (
        this.requestVector.modelType == 3 &&
        (this.requestVector.customCharacter == "" ||
          this.requestVector.customCharacter == null)
      ) {
        return this.$t("requiredField");
      } else {
        this.customCharacter = null;
      }
      return true;
    },
    validateTypeFile(type) {
      let doctype = 0;
      switch (type) {
        case "text/csv":
          doctype = 1;
          break;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          doctype = 2;
          break;
        case "application/pdf":
          doctype = 3;
          break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          doctype = 4;
          break;
        case "text/plain":
          doctype = 5;
          break;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          doctype = 6;
          break;
      }
      return this.doctype == doctype;
    },
    triggerFileUpload() {
        if (!this.validateUploadPrerequisites(true)) {
            this.clearDragDropRef();
            return;
        }

        if (this.$refs.dragDropRef?.$el) {
            const fileInput = this.$refs.dragDropRef.$el.querySelector('input[type="file"]');
            if (fileInput) {
                fileInput.click();
            }
        }
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(
        (file) => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit("filesUploaded", this.uploadedFiles);
    },
    Clear() {
      this.showTable = false;

      this.requestVector.entity = null;
      this.requestVector.modelId = null;
      this.requestVector.vectordbName = null;

      this.searchVectorDBName = null;
      this.searchVectorDBName2 = null;
      this.dataTable2 = [];
      this.searchTotalTable2 = 0;
      this.totalTable = 0;

      this.$emit("back", true);
    },
    linkDownload(modelType, filename) {
      let req = {
        modelType: modelType,
        filename: filename,
      };
      this.$call.DownloadTemplateVector_Stream(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = globalThis.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            let fileNameshow = `Template_${modelType}_${filename}${this.findTypeName(
              filename
            )}`;
            fileLink.setAttribute("download", fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          this.TemplateVector = false;
        },
        (errorResource) => {
          this.TemplateVector = false;
          console.error(errorResource);
        }
      );
    },
    findTypeName(filename) {
      return findTypeNameUtil(filename);
    },
    setTypeFile(val) {
      switch (val.value) {
        case 1:
          this.accept = ".csv";
          break;
        case 2:
          this.accept =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          break;
        case 3:
          this.accept = "application/pdf";
          break;
        case 4:
          this.accept =
            ".doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          break;
        case 5:
          this.accept = "text/plain";
          break;
        case 6:
          this.accept =
            ".ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation";
          break;
        default:
          this.accept = "";
          break;
      }
    },
    download() {
      const data = [];
      data.push("\ufefftext_org\r\n", "ปากกา 10 บาท\r\n", "ดินสอ 20 บาท\r\n", "ถาม:กินข้าว ตอบ:กินหมูปิ้ง");

      const a = document.createElement("a");
      let blob = new Blob(data, { type: "data:text/csv;charset=UTF-8" });
      const url = globalThis.URL.createObjectURL(blob);

      a.href = url;
      a.download = "upload_vector.csv";
      a.click();
      globalThis.URL.revokeObjectURL(url);
      a.remove();
    },
    cancelReprocess() {
      this.dialog_reprocess = false;
    },
    ReProcess() {
      this.dialog_reprocess = true;
    },
    GetDDGroupReplaceDB() {
      this.dialog = true;
      const vectordbName = this.$route.query.name || this.searchVectorDBName2;
      this.$call.GetDDGroupReplaceDBForVector(
        vectordbName,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDGroupReplace = dataResponse.data == null ? [] : dataResponse.data;
          } else {
            this.DDGroupReplace = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetMaxLimitedCharacter() {
      this.dialog = true;
      this.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.requestVector.MaxLimitedCharacter = dataResponse.data;
          } else {
            this.requestVector.MaxLimitedCharacter = null;
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    TemplateVectorDialog() {
      this.TemplateVector = true;
    },
    ShowAll() {
      this.ShowAllText = !this.ShowAllText;
      this.dataTable2.forEach((element) => {
        element.show = this.ShowAllText;
      });
    },
    CloseShowAll() {
      this.ShowAllText = !this.ShowAllText;
      this.dataTable2.forEach((element) => {
        element.show = this.ShowAllText;
      });
    },
    Search() {
      this.isSearch2 = true;
      this.options2.page = 1;
      this.ReFresh();
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    getFileIcon(fileName) {
      const extension = fileName.split('.').pop().toLowerCase();
      switch (extension) {
        case 'pdf':
          return this.images.pdfImg || this.images.excelImg;
        case 'doc':
        case 'docx':
          return this.images.wordImg || this.images.excelImg;
        case 'xls':
        case 'xlsx':
          return this.images.excelImg;
        case 'csv':
          return this.images.csvImg || this.images.excelImg;
        case 'txt':
          return this.images.txtImg || this.images.excelImg;
        case 'ppt':
        case 'pptx':
          return this.images.pptImg || this.images.excelImg;
        default:
          return this.images.excelImg;
      }
    },
    deleteSelectedFiles() {
      if (this.selectedFiles.length === 0) return;
      if(this.selectAll && this.selectedFiles.length === this.uploadedFiles.length) {
        this.deleteType = 'all';
      } else {
        this.deleteType = 'individual';
      }
      this.dialog_delete = true;
    },
    deleteSingleFile(fileToDelete) {
      this.deleteItem = fileToDelete;
      this.deleteType = 'single';
      this.dialog_delete = true;
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    clearDragDropRef() {
      if (this.$refs.dragDropRef) {
        // Clear the component's files array if it exists
        if (this.$refs.dragDropRef.files) {
          this.$refs.dragDropRef.files = [];
        }
        
        // Clear internal files if the component has this property
        if (this.$refs.dragDropRef.uploadedFiles) {
          this.$refs.dragDropRef.uploadedFiles = [];
        }
        
        // Try to call the component's clear method
        if (typeof this.$refs.dragDropRef.clearFiles === 'function') {
          this.$refs.dragDropRef.clearFiles();
        }
        
        // Clear the actual file input
        if (this.$refs.dragDropRef.$el) {
          const fileInputs = this.$refs.dragDropRef.$el.querySelectorAll('input[type="file"]');
          fileInputs.forEach(input => {
            input.value = '';
          });
        }
      }
      
      // Also clear our local files reference
      this.files = [];
    },
    nextStep() {
      this.errors.documentNameError = (!this.searchVectorDBName2 || this.searchVectorDBName2.trim() === '') ? this.$t('requiredField') : null;
      this.errors.doctypeError = this.doctype ? null : this.$t('requiredField');
      this.errors.vectortypeError = this.vectortype ? null : this.$t('requiredField');
      this.errors.modelTypeError = this.requestVector.modelType ? null : this.$t('requiredField');
      if (this.errors.documentNameError || this.errors.doctypeError || this.errors.vectortypeError || this.errors.modelTypeError) {
        return;
      }
      this.step = "2";
    },
    confirmDelete() {
      let fileToDelete = this.deleteItem;
      if(fileToDelete == 1) {
        this.dialog_delete = false;
        this.files = [];
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.selectAll = false;
        this.clearDragDropRef();
        this.requestVector.entity = null;
        return;
      }
      if(this.deleteType == 'all') {
        // Delete all files
        this.uploadedFiles = [];
        this.selectAll = false;
        this.requestVector.entity = null;
        // Clear drag-drop component
        this.clearDragDropRef();
      } else if(this.deleteType == 'individual') {
          this.uploadedFiles = this.uploadedFiles.filter(file => 
            !this.selectedFiles.some(selected => selected.id === file.id)
          );
          
          // Clear selected files
          this.selectedFiles = [];
          
          // Update the entity if no files left
          if (this.uploadedFiles.length === 0) {
            this.requestVector.entity = null;
            this.clearDragDropRef();
          } else {
            this.clearDragDropRef();
            // Update FormData with remaining files
            this.updateFormData();
          }
      } else {
          this.uploadedFiles = this.uploadedFiles.filter(file => file.name !== fileToDelete.name);
              
          // Remove from selected files if it was selected
          this.selectedFiles = this.selectedFiles.filter(file => file.name !== fileToDelete.name);
          
          // Update the entity if no files left
          if (this.uploadedFiles.length === 0) {
            this.requestVector.entity = null;
            this.clearDragDropRef();
          } else {
            this.clearDragDropRef();
            // Update FormData with remaining files
            this.updateFormData();
          }
      }
      
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    processUpload(e) {
      this.files = e;
      if (!this.validateUploadPrerequisites()) {
        this.requestVector.entity = null;
        this.files = [];
        this.clearDragDropRef();
        return;
      }

      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        this.selectedFiles = [];
        this.selectAll = false;
        return;
      }
      // Add new files to existing uploadedFiles array (avoid duplicates)
      const newFiles = this.files.filter(newFile =>
        !this.uploadedFiles.some(existingFile => existingFile.name === newFile.name)
      );
      // Reject the whole new batch and keep what was already added
      const totalBytes = [...this.uploadedFiles, ...newFiles].reduce((sum, file) => sum + file.size, 0);
      if (totalBytes > MAX_UPLOAD_BYTES) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('fileSizeExceeded'),
          text: this.$t('_uploadTotalSizeExceeded', { max: MAX_UPLOAD_MB, size: this.formatFileSize(totalBytes) }),
          showConfirmButton: true,
        });
        this.clearDragDropRef();
        return;
      }
      this.uploadedFiles = [...this.uploadedFiles, ...newFiles,];
      this.selectedFiles = []; // Clear selection when new files are added
      this.selectAll = false;

      if (this.uploadedFiles.length > 0) {
        // Read first file for validation (you may want to validate all files)
        const reader = new FileReader();
        reader.readAsText(this.uploadedFiles[0]); //NOSONAR
        reader.onload = () => {
          let text = reader.result;
          this.ValidateCSVVector(text, this.uploadedFiles);
        };
      }
      
    },
    validateUploadPrerequisites(showAlert = false) {
      this.errors.doctypeError = this.doctype ? null : this.$t('requiredField');
      this.errors.vectortypeError = this.vectortype ? null : this.$t('requiredField');
      this.errors.modelTypeError = this.requestVector?.modelType ? null : this.$t('requiredField');

      const hasError = Boolean(
        this.errors.doctypeError ||
        this.errors.vectortypeError ||
        this.errors.modelTypeError
      );

      if (hasError && showAlert) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('_pleaseSelectRequiredDropdowns'),
          showConfirmButton: false,
          timer: 1500,
        });
      }

      return !hasError;
    },
    showSuccessBanner(title, options = {}) {
      const {
        timer = 1500,
        backdrop = true,
        allowDismiss = false,
        popupClass = 'success-banner',
        titleClass = 'success-banner-title',
      } = options;
      const swalOptions = {
        title: title,
        showConfirmButton: false,
        timer: timer,
        position: 'top',
        backdrop: backdrop,
        customClass: {
          popup: popupClass,
          title: titleClass,
        },
      };
      if (allowDismiss) {
        swalOptions.allowOutsideClick = true;
        swalOptions.allowEscapeKey = true;
        swalOptions.allowEnterKey = true;
      }
      this.$swal.fire(swalOptions);
    },
    validateVectorCommonFields() {
      if (this.requestVector.modelType == 3 && !this.requestVector.customCharacter) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('_pleaseFillAllFields'),
          showConfirmButton: false,
          timer: 1500,
        });
        return false;
      }
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == '' || this.requestVector.MaxLimitedCharacter == undefined) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('_pleaseFillCustomMaxCharacter'),
          showConfirmButton: false,
          timer: 1500,
        });
        return false;
      }
      return true;
    },
    wrapUploadedFiles(files) {
      const wrapped = files.map((file, i) => {
        const originalFile = file.originalFile || file;
        return {
          id: i + 1,
          checked: false,
          name: originalFile.name,
          size: originalFile.size,
          type: originalFile.type,
          originalFile: originalFile, // keeps File ref for FormData
        };
      });
      for (let i = 0; i < wrapped.length; i++) {
        wrapped[i].id = i + 1;
        wrapped[i].checked = false;
      }
      return wrapped;
    },
    appendCommonVectorFields(formDataDoc, maxLimitedCharacterValue) {
      formDataDoc.append('DetectLanguage', this.requestVector.DetectLanguage || false);
      formDataDoc.append('MaxLimitedCharacter', maxLimitedCharacterValue);

      if (this.requestVector.customCharacter) {
        formDataDoc.append('customCharacter', this.requestVector.customCharacter);
      }
      if (this.tempgroupReplaceID) {
        formDataDoc.append('groupReplaceID', JSON.stringify(this.tempgroupReplaceID));
      }
    },
    filterVectorNameChars(pastedText) {
      // กรองเฉพาะตัวอักษรที่อนุญาตเท่านั้น (รวมเครื่องหมายขีด และเครื่องหมายขีดล่าง)
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F\-_]+$/;
      let filteredText = '';

      // วนลูปตรวจสอบแต่ละตัวอักษรในข้อความที่วาง
      for (let i = 0; i < pastedText.length; i++) {
        const char = pastedText.charAt(i);
        if (validCharactersRegex.test(char)) {
          filteredText += char;
        }
      }
      return filteredText;
    },
    executeReprocess(beforeCall) {
      if (this.requestVector.MaxLimitedCharacter == null || this.requestVector.MaxLimitedCharacter == '' || this.requestVector.MaxLimitedCharacter == undefined) {
        alert(this.$t('_pleaseFillCustomMaxCharacter'));
        return;
      }
      try {
        if (beforeCall) {
          beforeCall();
        }
        let data = {
          vectordbName: this.searchVectorDBName2,
          MaxLimitedCharacter: this.requestVector.MaxLimitedCharacter,
          groupReplaceID: this.tempgroupReplaceID == null ? null : JSON.stringify(this.tempgroupReplaceID),
          DetectLanguage: this.requestVector.DetectLanguage,
        };
        this.$call.ReProcessedVector(
          data,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.showSuccessBanner('✔ ' + dataResponse.message);
              this.GetByVector();
            }
          },
          (errorResource) => {
            console.error(errorResource.message);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'ReProcess');
      }
    },
    shouldStopAutoRefresh() {
      const hasVectorName =
        (this.$route.query.name != null && this.$route.query.name != "") ||
        (this.searchVectorDBName2 != null && this.searchVectorDBName2 != "");
      if (hasVectorName) {
        if (this.dataUpdate == this.dataAll || this.exceptionFlag || (this.dataUpdate <= 0 && this.dataAll <= 0))
        {
          return true;
        }
        else
        {
          this.ReFresh();
        }
        if (globalThis.location.pathname != "/UploadVector")
          return true;
        return false;
      } else if(this.$route.query.name == null) {
        this.loadingTable = false;
        return true;
      } else { //NOSONAR
        this.loadingTable = false;
        return true;
      }
    },
  },
};
